import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { AsignacionComponent } from './asignacion/asignacion.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { CuestionariosAsignadosComponent } from './cuestionarios-asignados/cuestionarios-asignados.component';
import { Cuestionariov2Component } from './cuestionariov2/cuestionariov2.component';

const routes: Routes = [
  {
    path: 'app/cuestionarios',
    component: ContenedorComponent,
    children: [
      {path: 'asignacion', component: AsignacionComponent, canActivate: [authGuardSubmodule]},
      {path: 'cuestionarios-asignados', component: CuestionariosAsignadosComponent, canActivate: [authGuardSubmodule]},
/*       {path: 'cuestionario/:hash', component: Cuestionariov2Component, canActivate: [authGuardSubmodule]}, */

    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CuestionariosRoutingModule { }
